import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import BookingCalendar from "@/pages/BookingCalendar";
import MyBookings from "@/pages/MyBookings";
import BuyCredits from "@/pages/BuyCredits";
import Admin from "@/pages/Admin";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLogin from "@/pages/AdminLogin";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/admin-login" element={<AdminLogin />} />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <Layout><Dashboard /></Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/calendar"
                            element={
                                <ProtectedRoute>
                                    <Layout><BookingCalendar /></Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/bookings"
                            element={
                                <ProtectedRoute>
                                    <Layout><MyBookings /></Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/credits"
                            element={
                                <ProtectedRoute>
                                    <Layout><BuyCredits /></Layout>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute adminOnly>
                                    <Layout><Admin /></Layout>
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                    <Toaster richColors closeButton position="top-right" />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
